var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1581"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1 24.5C11.66 24.5 11.2833 24.3409 10.97 24.0227C10.6567 23.7044 10.5 23.3219 10.5 22.875V13.125C10.5 12.6781 10.6567 12.2956 10.97 11.9773C11.2833 11.6591 11.66 11.5 12.1 11.5H24.9C25.34 11.5 25.7167 11.6591 26.03 11.9773C26.3433 12.2956 26.5 12.6781 26.5 13.125V22.875C26.5 23.3219 26.3433 23.7044 26.03 24.0227C25.7167 24.3409 25.34 24.5 24.9 24.5H12.1ZM18.5 18.8125L24.9 14.75V13.125L18.5 17.1875L12.1 13.125V14.75L18.5 18.8125Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.ef351e7b351abc209d2d3d1f1787323c.svg";
export { ForwardRef as ReactComponent };